import React from "react";
import { useInfiniteScroll } from "@hooks/useInfiniteScroll";
import { NoData } from "@components/common/NoData/NoData";
import type { InfiniteScrollProps } from "./types/types";
import { useTranslation } from "react-i18next";

const InfiniteScroll = <T extends { id: string | number }>({
	items,
	renderItem,
	hasNextPage,
	fetchNextPage,
	isFetching,
	noDataMessage,
	className = "px-[10px] sm:px-[20px] my-8 p-5 grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-5",
	scrollRootId,
}: InfiniteScrollProps<T>) => {
	const lastItemRef = useInfiniteScroll(isFetching, hasNextPage, fetchNextPage, scrollRootId);
	const { t } = useTranslation();
	if (items.length === 0) {
		return <NoData msg={noDataMessage} />;
	}

	return (
		<div id={scrollRootId} className={className}>
			{items.map((item, index) => (
				<React.Fragment key={item.id}>
					{renderItem(item, index)}
					{index === items.length - 1 && <div ref={lastItemRef} />}
				</React.Fragment>
			))}
			{isFetching && (
				<div className="col-span-full flex justify-center">
					<span>{t("psdaCommon.common.loading")}</span>
				</div>
			)}
		</div>
	);
};

export default InfiniteScroll;
